import { render, staticRenderFns } from "./createItems.vue?vue&type=template&id=e4a6c7fe&"
import script from "./createItems.vue?vue&type=script&lang=js&"
export * from "./createItems.vue?vue&type=script&lang=js&"
import style0 from "./createItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports